/**
 * Custom Hamburger Icon
 * Two horizontal lines - top shorter, bottom full width
 * Matches Figma design
 */

interface HamburgerIconProps {
  size?: number;
  className?: string;
}

export function HamburgerIcon({ size = 24, className }: HamburgerIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      className={className}
    >
      {/* Top line - full width */}
      <line x1="4" y1="8" x2="20" y2="8" />
      {/* Bottom line - shorter, right-aligned */}
      <line x1="10" y1="16" x2="20" y2="16" />
    </svg>
  );
}

export default HamburgerIcon;
